import Vue from 'vue';
import Cookies from 'js-cookie';


export default {
  state: {
    profile:{},
    currentClient: '2B',
    clientCk:'hcm_sid',
    loginAddress: 'https://www.yunxiao.com'
  },
  actions: {
    // 获取用户信息
    userInfo(ctx) {
      return Vue.http.post('/client/user/user-Info').then(data=> {
        if(data && data.userName && data.userName.indexOf(',') > -1){
          data.userName = data.userName.split(',')[0];
        }
        ctx.commit('setProfile', data);
      }).catch(err=> {
        ctx.commit('setProfile', { userName:'', isMember: 0 });
      })
    }
  },
  mutations: {
    setProfile(state, payload){
      state.profile = payload || {};
    },
    clearInfo(state){
      Cookies.remove(state.clientCk, { path: '/', domain: '.yunxiao.com' });
      state.profile = {};
      window.location.href = state.loginAddress;
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js